import * as types from '../mutation-types'
import markService from '../../services/marks'

const state = {
    loading: false,
    errors: null,
    marks: []
}

const actions = {
    getAll({ commit }, data) {
        commit(types.MARK_LOADING, true)
        markService.getAll(data).then(
            response => {

                commit(types.LOAD_MARKS, response.data)
                commit(types.MARK_LOADING, false)
                commit(types.MARK_FAILURE, null)
            },
            error => {
                commit(types.MARK_FAILURE, error)
                commit(types.MARK_LOADING, false)
            }
        )
    },
    add({ commit }, data) {

        commit(types.MARK_LOADING, true)
        commit(types.MARK_FAILURE, null)
        markService.add(data).then(
            response => {
                //console.log('responseooo', response)

                //commit(types.ADD_MARK, response.data)
                commit(types.MARK_LOADING, false)

            },
            error => {
                commit(types.MARK_FAILURE, error)
                commit(types.MARK_LOADING, false)
            }
        )
    },
    set_cs({commit},val){
      commit(types.SET_CS, val)
    },
    set_es({commit},val){
      commit(types.SET_ES, val)
    }


}

const mutations = {
    [types.ADD_MARK](state, payload) {
        state.marks = payload;
    },
    [types.LOAD_MARKS](state, payload) {
        state.marks = payload
    },

    [types.MARK_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.MARK_LOADING](state, payload) {
        state.loading = payload
    },
    [types.SET_CS](state, payload){
      //console.log("founddsss",state.marks[payload.idx])
     state.marks[payload.idx].s_mark.class_score = payload.score
    },
    [types.SET_ES](state, payload){
      state.marks[payload.idx].s_mark.exam_score = payload.score
    }
}

const getters = {
    MARKS: state => {
        return state.marks
    },

    MARK_ERROR: state => {
        return state.errors
    },

    MARK_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/marks.js